module.exports = __webpack_public_path__ + "media/img/logo-transparent-sm-dark-bare-f0dc6465bd60003d684fc289d30984c5.png";